import React from 'react';
import NotifikationForm from '../components/forms/NotifikationForm';
import DannebrogFlag from '../components/shared/DannebrogFlag';
import styles from './Notifikationer.module.scss';

const Notifikationer: React.FC = () => {
  return (
    <div className={styles.page}>
      <div className={`${styles.content} container`}>
        <h1 className={styles.pageTitle}>Notifikationer</h1>

        <div className={styles.infoCard}>
          <p className={styles.lead}>
            Modtag besked når der er flagdag eller mærkedag på Askevej.
          </p>
          <p>
            Du kan vælge at blive notificeret om officielle danske flagdage,
            mærkedage tilføjet af beboere på Askevej, og fødselsdage.
          </p>
        </div>

        <div className={styles.formCard}>
          <h2 className={styles.formTitle}>Tilmeld dig</h2>
          <NotifikationForm />
        </div>

        <div className={styles.explainCard}>
          <h2 className={styles.explainTitle}>Hvad indeholder emailsene?</h2>
          <ul className={styles.explainList}>
            <li>
              <span className={styles.bullet}><DannebrogFlag size={18} /></span>
              <span>
                <strong>Officielle flagdage:</strong> En påmindelse om at hejse
                Dannebrog, med en kort beskrivelse af dagen.
              </span>
            </li>
            <li>
              <span className={styles.bullet}>📅</span>
              <span>
                <strong>Mærkedage:</strong> Besked om særlige dage tilføjet
                af beboere på Askevej.
              </span>
            </li>
            <li>
              <span className={styles.bullet}>🎂</span>
              <span>
                <strong>Fødselsdage:</strong> En blid påmindelse om at ønske
                tillykke til naboerne.
              </span>
            </li>
          </ul>
          <p className={styles.note}>
            Vi sender aldrig spam. Du kan til enhver tid afmelde dig ved at
            kontakte os eller klikke på afmeld-linket i emailen.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Notifikationer;
